import { render, staticRenderFns } from "./ChangePasswordScreen.vue?vue&type=template&id=40e49d0e&"
import script from "./ChangePasswordScreen.vue?vue&type=script&lang=js&"
export * from "./ChangePasswordScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbrown/projects/okinus/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40e49d0e')) {
      api.createRecord('40e49d0e', component.options)
    } else {
      api.reload('40e49d0e', component.options)
    }
    module.hot.accept("./ChangePasswordScreen.vue?vue&type=template&id=40e49d0e&", function () {
      api.rerender('40e49d0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/features/profile/screens/ChangePasswordScreen.vue"
export default component.exports